<script>import { requiredRule } from "../../../utils/forms";
import { attrValue, shortId } from "../../../utils/html";
import { undefOrNull } from "../../../utils/objects";
import InputLabel from "./InputLabel.svelte";
import { onDestroy } from "svelte";
export let props = null;
export let isLabelHidden = null;
const isInputCheckboxProps = (arg) => {
  return !!arg && arg.key && arg.key === "checkbox";
};
$: if (props) {
  props.validation = props.validation ?? { rules: [] };
  if (props.validation.rules) {
    let hasRequiredRules = props.validation.rules.some((r) => r.key === "required");
    if (props.required && !hasRequiredRules) {
      props.validation = {
        ...props.validation,
        rules: [...props.validation.rules, requiredRule()]
      };
    } else if (!props.required) {
      props.validation = {
        ...props.validation,
        rules: []
      };
    }
  }
}
$: if (props && props.validation) {
  let isValid = true;
  if (props.validation.rules?.length) {
    props.validation.rules.forEach((rule, index) => {
      let isRuleValid = !!rule.check && (!undefOrNull(props.value) && rule.check(props.value) || isInputCheckboxProps(props) && rule.check(props.checked));
      if (props.validation?.rules && props.validation.rules[index]) {
        props.validation.rules[index] = { ...rule, valid: isRuleValid };
        isValid = isValid && isRuleValid;
      }
    });
  }
  props.validation.valid = isValid;
}
$: if (props) {
  props.id = props && props.id ? props.id : `input_${shortId()}`;
}
onDestroy(() => {
  if (props) {
    props.touched = false;
    props.dirty = false;
    props.focus = false;
    props.touchedTwice = false;
    delete props.validation;
  }
});
</script>

{#if props}
	<div class={attrValue([props.classNames, 'w-full'])}>
		{#if !isLabelHidden && (props.icon || props.label || props.hint)}
			<InputLabel {props} />
		{/if}

		<slot />

		{#if props.error}
			<p class="text-sm text-danger mt-1 ml-1">{props.error}</p>
		{/if}
		{#if props.warning}
			<p class="text-sm text-warning mt-1 ml-1">{props.warning}</p>
		{/if}

		{#if props.description}
			<p class="mt-1 italic text-xs">{@html props.description}</p>
		{/if}
	</div>
{/if}

<style>div :global(.input),div :global(.select),div :global(.textarea){border-radius:.5rem;border-width:1px;display:block;filter:none;padding-right:3rem;width:100%}div :global(.input)::-moz-placeholder,div :global(.select)::-moz-placeholder,div :global(.textarea)::-moz-placeholder{--tw-placeholder-opacity:1;color:#c4c4c4;color:rgba(196,196,196,var(--tw-placeholder-opacity,1))}div :global(.input)::placeholder,div :global(.select)::placeholder,div :global(.textarea)::placeholder{--tw-placeholder-opacity:1;color:#c4c4c4;color:rgba(196,196,196,var(--tw-placeholder-opacity,1))}div :global(.input),div :global(.select),div :global(.textarea){outline:2px solid transparent;outline-offset:2px;transition-duration:.15s;transition-property:color,background-color,border-color,text-decoration-color,fill,stroke,opacity,box-shadow,transform,filter,-webkit-backdrop-filter;transition-property:color,background-color,border-color,text-decoration-color,fill,stroke,opacity,box-shadow,transform,filter,backdrop-filter;transition-property:color,background-color,border-color,text-decoration-color,fill,stroke,opacity,box-shadow,transform,filter,backdrop-filter,-webkit-backdrop-filter;transition-timing-function:cubic-bezier(.4,0,.2,1);--tw-ring-offset-shadow:var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);--tw-ring-shadow:var(--tw-ring-inset) 0 0 0 calc(var(--tw-ring-offset-width)) var(--tw-ring-color);box-shadow:var(--tw-ring-offset-shadow),var(--tw-ring-shadow),0 0 transparent;box-shadow:var(--tw-ring-offset-shadow),var(--tw-ring-shadow),var(--tw-shadow,0 0 transparent)}div :global(.input):focus,div :global(.select):focus,div :global(.textarea):focus{outline:2px solid transparent;outline-offset:2px;--tw-ring-offset-shadow:var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);--tw-ring-shadow:var(--tw-ring-inset) 0 0 0 calc(var(--tw-ring-offset-width)) var(--tw-ring-color);box-shadow:var(--tw-ring-offset-shadow),var(--tw-ring-shadow),0 0 transparent;box-shadow:var(--tw-ring-offset-shadow),var(--tw-ring-shadow),var(--tw-shadow,0 0 transparent)}div :global(.input),div :global(.select){height:50px}div :global(.input::-webkit-input-placeholder){font-weight:300}div :global(.input::-moz-placeholder){font-weight:300}div :global(.input::-ms-input-placeholder){font-weight:300}div :global(.textarea::-webkit-input-placeholder){font-weight:300}div :global(.textarea::-moz-placeholder){font-weight:300}div :global(.textarea::-ms-input-placeholder){font-weight:300}</style>
